import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IGetShouldAutoShowDataOrientationPaneParams {
  user: string;
}

export interface IGetShouldAutoShowDataOrientationPaneResult extends IResult {
  shouldShowPane: boolean;
}
export class GetShouldAutoShowDataOrientationPaneRequest extends Request<IGetShouldAutoShowDataOrientationPaneParams, IResult> {
  constructor(params: IGetShouldAutoShowDataOrientationPaneParams) {
    super('getShouldAutoShowDataOrientationPane', params);
  }
}
